import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { PostCard } from "../components/PostCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api
      .get("/search", { params: { q } })
      .then((r) => setResults(r.data))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div data-testid="search-page" className="mx-auto max-w-[1400px] px-4 py-10 sm:px-6 sm:py-16 lg:px-12 lg:py-24">
      <div className="mb-8 border-b border-white/10 pb-8 sm:mb-12 sm:pb-10">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#D4FF00] sm:text-xs">Search</div>
        <h1 className="mt-3 font-display text-3xl font-bold leading-none tracking-tighter text-white sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
          "{q}"
        </h1>
        <p className="mt-4 text-sm uppercase tracking-[0.2em] text-white/50">
          {loading ? "searching…" : `${results.length} result${results.length === 1 ? "" : "s"}`}
        </p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {results.map((p) => <PostCard key={p.id} post={p} />)}
      </div>
      {!loading && results.length === 0 && q && (
        <div className="py-20 text-center text-sm uppercase tracking-[0.2em] text-white/40">No matches — try another term.</div>
      )}
    </div>
  );
}
